import React, { Component } from 'react';
import {Route} from 'react-router-dom'
import locale from './lang/locale.json';
import PropTypes from "prop-types";

class PublicRoute extends Component {
    static propTypes = {
        path : PropTypes.string,
        locale : PropTypes.string,
    };

    checkRedirect(match){
        const Tag = this.props.component;
        return <Tag id={match.params.id} locale={locale[this.props.locale]}/>
    }

    render() {
        return (
            <Route exact path={this.props.path} render={({match}) => this.checkRedirect(match)}/>
        );
    }
}

export default(PublicRoute)


// WEBPACK FOOTER //
// ./src/PublicRoute.js